module.exports = __webpack_public_path__ + "assets/img/store_system.bcb092fe.png";